import { AutogenLayoutGLDistributionTable } from "./autogen/AutogenLayoutGLDistributionTable";

export class GLDistributionTable extends AutogenLayoutGLDistributionTable {
   
}
